import React, { useEffect } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { AuthData } from '../../provider/AuthProvider';
import { nav } from './Navs';

const StudentRoutes = () => {
    const { user, loading } = AuthData();
    
    useEffect(() => {
        console.log('🔄 StudentRoutes - User state:', {
            hasUser: !!user,
            isAuthenticated: user?.isAuthenticated,
            uid: user?.userd?.uid,
            loading
        });
    }, [user, loading]);

    // Show loading spinner while authentication is being determined
    if (loading) {
        return (
            <div className="min-h-screen flex items-center justify-center bg-gray-50">
                <div className="text-center">
                    <div className="animate-spin rounded-full h-16 w-16 border-b-2 border-orange-500 mx-auto mb-4"></div>
                    <p className="text-gray-600">Loading...</p>
                </div>
            </div>
        );
    }

    return (
        <Routes>
            {nav.map((r, i) => {
                if (r.isPrivate) {
                    // Private routes - require authentication
                    return (
                        <Route 
                            key={i} 
                            path={r.path} 
                            element={
                                user?.isAuthenticated ? 
                                r.element : 
                                <Navigate to="/main-signup" replace />
                            }
                        />
                    );
                } else {
                    // Public routes - always accessible
                    return (
                        <Route 
                            key={i} 
                            path={r.path} 
                            element={r.element}
                        />
                    );
                }
            })}
        </Routes>
    );
};

export default StudentRoutes;